import classNames from "classnames";
import { useNavigationToggle } from "../../../../contexts/NavigationContext";
import Icon from "../../../atoms/Icon";
import styles from "./styles.scss";

const NaviMenuSPOpenButton = () => {
  const { isNavigationOpen, toggleNavigation } = useNavigationToggle();

  return (
    <button
      className={classNames(styles.root, { [styles.opened]: isNavigationOpen })}
      onClick={toggleNavigation}
    >
      <div className={styles.button}>
        <Icon name="icon-navi-menu" className={styles.icon} />
      </div>
    </button>
  );
};

export default NaviMenuSPOpenButton;
